<template>
  <div v-for="(metadata, key) in metadata" :key="key">
    <div class="text--bold mb-2 text-text-secondary">{{ metadata.label }}</div>
    <AppMultiSelect
      :model-value="selectedValues[key] || []"
      @update:modelValue="(val: string[]) => onSelectChange(key, val)"
      :items="metadata.values || []"
      item-title="label"
      item-value="key"
      :placeholder="metadata.label"
      data-locator="metadata-filter-select"
    >
      <template #no-data>
        <ProjectsFiltersNoData :label="metadata.label" />
      </template>
    </AppMultiSelect>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

import AppMultiSelect from '@/common/AppMultiSelect.vue'
import roomsService from '@/services/rooms.service'

import ProjectsFiltersNoData from './ProjectsFiltersNoData.vue'

type Metadata = {
  label: string
  values: { key: string; label: string }[]
}

const store = useStore()
const filtersPane = store.state.rooms.filtersPane

const metadata = ref<Record<string, Metadata>>({})
const selectedValues = ref<Record<string, string[]>>({})

const emit = defineEmits<(e: 'update:metadata', payload: Record<string, string[]>) => void>()

function onSelectChange(key: string, value: string[]) {
  selectedValues.value[key] = value
  emit('update:metadata', { ...selectedValues.value })
}

onMounted(async () => {
  try {
    const { data } = await roomsService.getExistingRoomMetadata()
    metadata.value = data.metadata
    store.commit('rooms/SET_EXISTING_METADATA', metadata.value)
    for (const key in metadata.value) {
      selectedValues.value[key] = filtersPane.filters.metadata?.[key] ?? []
    }
  } catch (e) {
    console.error('Failed to fetch metadata:', e)
  }
})
watch(
  () => filtersPane.filters.metadata,
  (newMetadata: { [x: string]: never[] }) => {
    for (const key in metadata.value) {
      selectedValues.value[key] = newMetadata?.[key] ?? []
    }
  },
  { deep: true },
)
</script>
